import { Component } from '@angular/core';

import { DynamicFormControlBaseComponent } from './dynamic-form-control.base-component';

@Component({
  template: '',
  selector: 'lh-dynamic-form-select-base',
  standalone: false,
})
export abstract class DynamicFormSelectBaseComponent extends DynamicFormControlBaseComponent {}
